import React from 'react';
import { IndexRoute, Route } from 'react-router';
import Activate from './activate';

export default (
  <Route path="activate">
    <IndexRoute component={props => <Activate />} />
    {/* 
        <Route path='create' component={(props) => <QuizCreateForm {...props} />} />
        <Route path='manage' component={(props) => <ManageQuiz {...props} />} /> */}
  </Route>
);
